<template>
  <div class="loading-bar my-11 overflow-hidden rounded-md px-px py-px gap-0.5 lg:w-96 md:w-7/12 w-10/12 h-7 max-w-sm flex items-center">
    <div class="loading-box inline-block h-5/6 w-4"></div>
    <div class="loading-box inline-block h-5/6 w-4"></div>
    <div class="loading-box inline-block h-5/6 w-4"></div>
  </div>
</template>
